import { Box, Heading, Stack, Text } from '@chakra-ui/react'
import { useState } from 'react'
import QuestionCarouselNavigation from '../../../../components/QuestionCarouselNavigation'
import { BasicReport } from '../utils/types'
import { partAQuestions } from '../utils/constants'
import PartAPercentageInput from './PartAPercentageInput'

interface PartACarouselProps {
  values: BasicReport
  onChange: (name: keyof BasicReport, value: string) => void
}

export default function PartACarousel({
  values,
  onChange,
}: PartACarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const current = partAQuestions[currentIndex]
  const total = partAQuestions.length

  return (
    <Stack spacing={4}>
      <Box
        bg='purple.50'
        borderColor='purple.100'
        borderRadius='lg'
        borderWidth='1px'
        p={6}
      >
        <Stack align='stretch' spacing={6}>
          <Text color='gray.500' fontSize='lg' textAlign='center'>
            {currentIndex + 1} of {total}
          </Text>
          <Heading fontSize='xl' overflowWrap='anywhere' textAlign='center' whiteSpace='normal'>
            {current.question}
          </Heading>
          <PartAPercentageInput
            onChange={(value) => onChange(current.name, value)}
            question={current.question}
            value={values[current.name]}
          />
          <QuestionCarouselNavigation
            isNextDisabled={currentIndex === total - 1}
            isPreviousDisabled={currentIndex === 0}
            onNext={() => setCurrentIndex((index) => Math.min(index + 1, total - 1))}
            onPrevious={() => setCurrentIndex((index) => Math.max(index - 1, 0))}
          />
        </Stack>
      </Box>
    </Stack>
  )
}
